import { gql } from '@apollo/client'
import { merchantAccountsFragment, merchantClassificationFragment } from '../fragments/merchantFragments'

export const GET_MERCHANT_DETAILS = gql`
	query GetMerchantDetails($currentMerchantID: String!) {
		merchant(merchantID: $currentMerchantID) {
			id
			name
			isClaimed
			coverImageUrl
			externalName
			logoUrl
			messaging
			country
			currency
			website
			pids
			masterID
			refundPeriodDays
			marketActivityPeriodDays
			tags {
				name
				description
			}
			isOnline
			statistics{
				merchantID
				averageCustomerReturnRate
			}
			...merchantClassification
			...merchantAccounts
		}
	}
	${merchantAccountsFragment}
	${merchantClassificationFragment}
`

export const GET_MERCHANT_CONTRACTS_WITH_USER = gql`
	query GetMerchantContracts($currentMerchantID: String!) {
		contracts(merchantID: $currentMerchantID) {
			id
			user {
				firstName
				lastName
			}
			status
			url
			updateTime
		}
	}
`

export const GET_MERCHANT_CONTRACTS = gql`
	query GetMerchantContracts($currentMerchantID: String!) {
		contracts(merchantID: $currentMerchantID) {
			id
			status
			updateTime
		}
	}
`

export const GET_MERCHANT_PAYMENT_HISTORY = gql`
	query MerchantPaymentHistory($currentMerchantID: String!) {
		merchant(merchantID: $currentMerchantID) {
			id
			payments {
				id
				reference
				total
				amount
				vat
				currency
				createTime
				receiptURL
			}
		}
	}
`

export const GET_MERCHANT_BILLING_INFO = gql`
	query PaymentInformationQuery($currentMerchantID: String!) {
		merchant(merchantID: $currentMerchantID) {
			id
			pids
			masterID
			messaging
			billingInfo {
				firstName
				lastName
				email
				address
				postCode
				city
				country
				organisationNumber
			}
		}
	}
`

export const GET_MERCHANT_BALANCE_BURNDOWN = gql`
	query($currentMerchantID: String!, $from: Time!) {
		merchant(merchantID: $currentMerchantID) {
			id
			accounts(type: default) {
				burndown(from: $from) {
					money {
						amount
						code
					}
					period {
						start{
							timestamp
						}
						end{
							timestamp
						}
					}
				}
			}
		}
	}
`

export const GET_MERCHANT_COMPETITORS = gql`
	query merchantCompetitors($currentMerchantID: String!) {
		merchant(merchantID: $currentMerchantID) {
			id
			competitorList {
				id
				name
			}
		}
	}
`

export const SEARCH_MERCHANTS = gql`
	query($value: String!, $countryCode: String!) {
		merchants(text: $value, country: $countryCode) {
			id
			logoUrl
			name
			classification {
				name
				child {
					name
				}
			}
		}
	}
`

const merchantSearchResultFields = gql`
	fragment MerchantSearchResultFields on Merchant {
		id
		logoUrl
		name
		country
		classification {
			name
			child {
				name
				child {
					name
				}
			}
		}
	}
`

export const SEARCH_SELECTOR_MERCHANTS = gql`
	query SearchSelectorMerchants($value: String!, $country: String!) {
		merchants(text: $value, country: $country) {
			...MerchantSearchResultFields
		}
	}
	${merchantSearchResultFields}
`

export const SEARCH_MERCHANTS_BY_PID = gql`
	query SearchMerchantsByPid($countryCode: String!, $pids: [String!]!) {
		merchantsByPids(countryCode: $countryCode, pids: $pids) {
			pid
			status
			merchant {
				...MerchantSearchResultFields
			}
		}
	}
	${merchantSearchResultFields}
`
